import { PaymentType } from '@/features/graphql/generated/graphql'
import { ReconciliationMode } from '@/features/shiftCloseouts/types'

export const paymentTypeOrder: Record<PaymentType, number> = {
    [PaymentType.Cash]: 10,
    [PaymentType.CardOnsite]: 20,
    [PaymentType.Online]: 30,
    [PaymentType.MealVoucher]: 40,
    [PaymentType.MealVoucherCard]: 50,
    [PaymentType.Invoice]: 60,
}

export const paymentReconciliationModes: Record<PaymentType, ReconciliationMode> = {
    [PaymentType.Cash]: 'manual',
    [PaymentType.CardOnsite]: 'manual',
    [PaymentType.Online]: 'automatic',
    [PaymentType.MealVoucher]: 'manual',
    [PaymentType.MealVoucherCard]: 'manual',
    [PaymentType.Invoice]: 'manual',
}
